<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.136 12.028L4.085 8.84101C3.418 8.48901 3 7.79701 3 7.04301V7.01001C3 5.90501 3.895 5.01001 5 5.01001H18.967C20.09 5.01001 21 5.92001 21 7.04301V7.06301C21 7.80501 20.589 8.48701 19.932 8.83301L13.864 12.029C12.697 12.643 11.303 12.643 10.136 12.028Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.99899 7.01001V16.01C2.99899 17.667 4.34199 19.01 5.99899 19.01H17.999C19.656 19.01 20.999 17.667 20.999 16.01V7.01001"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>